// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"267":"AppraisalDetailsPage","305":"SettingsPage","505":"InsightsPage"}[chunkId] + "." + {"267":"6782b953","305":"6782b953","505":"6782b953"}[chunkId] + ".chunk.css";
};